// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"719":"abe264bf","805":"60794f79"}[chunkId] + ".chunk.css";
};